import { useEffect, useRef, useState } from 'react';
import { useIoContext } from '~/providers/IoContext';
export const useStickyLabel = (value, minMs)=>{
    const { getNow } = useIoContext();
    const [displayed, setDisplayed] = useState(value);
    const shownAtRef = useRef(value === undefined ? null : getNow().getTime());
    const timerRef = useRef(null);
    useEffect(()=>{
        if (value === displayed) return;
        if (displayed === undefined) {
            setDisplayed(value);
            shownAtRef.current = value === undefined ? null : getNow().getTime();
            return;
        }
        const elapsed = shownAtRef.current == null ? minMs : getNow().getTime() - shownAtRef.current;
        const remaining = minMs - elapsed;
        if (timerRef.current != null) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        if (remaining <= 0) {
            setDisplayed(value);
            shownAtRef.current = value === undefined ? null : getNow().getTime();
            return;
        }
        timerRef.current = setTimeout(()=>{
            timerRef.current = null;
            setDisplayed(value);
            shownAtRef.current = value === undefined ? null : getNow().getTime();
        }, remaining);
    }, [
        value,
        displayed,
        minMs,
        getNow
    ]);
    useEffect(()=>()=>{
            if (timerRef.current != null) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        }, []);
    return displayed;
};
